export default __webpack_public_path__ + "static/media/restaurant.7b01b469.png";